<template>
  <div class="global-loader">
    <img id="global-loader-img" data-testid="global-loader-img" src="../assets/sproutspinner.gif" alt="global-loader-img" />
  </div>
</template>
<style scoped>
.global-loader {
  @apply tw-fixed tw-bg-neutral-0 tw-z-[999999];
  width: 100vw;
  height: 100vh;
  display: grid;
  place-items: center;
}
</style>
<script>
export default {
  name: 'SPAGlobalLoader',
};
</script>
